import {
  Autocomplete,
  Avatar,
  List,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  TextField,
  ListItemSecondaryAction,
  Typography,
  Box,
} from "@mui/material";
import { isNil, omitBy } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  useGetDeliveryCompaniesAdminQuery,
  useGetDeliveryCompaniesQuery,
} from "src/_api/mapitShipApi";
import { ROLES } from "src/constants";

export default function SelectDeliveryCompany({ value, onChange, orderId }) {
  console.log("orderId", orderId);

  const { t } = useTranslation();
  const { profile } = useSelector((state) => state.entities.profile);
  const [serviceType , setServiceType] = useState("")

const queryArgs = omitBy(
  {
    orderId,
    serviceType,
  },
  (v) => !v
);
const queryArgsAdmin = omitBy(
  {
    id: orderId,
    serviceType,
  },
  (v) => !v
);

  const { data: companiesMerchant, isLoading: companiesMerchantLoaing } =
    useGetDeliveryCompaniesQuery(queryArgs, {
      skip: profile?.merchant?.role !== ROLES.merchant,
    });
  const { data: companiesAdmin, isLoading: companiesAdminLoaing } =
    useGetDeliveryCompaniesAdminQuery(queryArgsAdmin, {
      skip: profile?.role !== ROLES.admin,
    });
  const companies =
    profile?.role === ROLES.admin ? companiesAdmin : companiesMerchant;
  const companiesLoaing = companiesMerchantLoaing || companiesAdminLoaing;
  console.log("value", value);

  return (
    <>
      <Autocomplete
        fullWidth
        getOptionLabel={(option) => option?.deliveryOptionName ?? ""}
        onChange={(_, newValue) => {
          onChange({ orderId, deliveryCompany: newValue });
        }}
        value={value ?? null}
        size="small"
        loading={companiesLoaing}
        loadingText={t("loading data...")}
        options={companies?.deliveryCompany ?? []}
        ListboxComponent={({ children, ...props }) => (
          <List {...props}>{children}</List>
        )}
        renderOption={(props, option) => (
          <ListItemButton {...props}>
            <ListItemAvatar>
              <Avatar
                src={option.logo}
                variant="square"
                sx={{ width: 40, height: 40 }}
              />
            </ListItemAvatar>
            <ListItemText
              primary={option.deliveryOptionName}
              primaryTypographyProps={{ variant: "subtitle1" }}
            />
            <ListItemSecondaryAction>
              <Typography variant="subtitle1">{option?.price}</Typography>
            </ListItemSecondaryAction>
          </ListItemButton>
        )}
        renderInput={(params) => <TextField {...params} label={t("Search")} />}
      />

    </>
  );
}
